import Text from '@cartwhl/ui/base/Text';
import CheckmarkIcon from '@cartwhl/ui/icons/CheckmarkIcon';
import CrossIcon from '@cartwhl/ui/icons/CrossIcon';
import Button from '@cartwhl/ui/input/Button';

import AssetLibraryThumbnail from '../../AssetLibrary/components/AssetLibraryThumbnail';

export interface ComicVideoUploadRowProps {
  index: number;
  label: string;
  thumbnailUrl: string;
  onRemove: () => void;
}

export default function ComicVideoUploadRow({
  index,
  label,
  thumbnailUrl,
  onRemove,
}: ComicVideoUploadRowProps) {
  const formattedIndex = `${String(index + 1).padStart(2, '0')}.`;

  return (
    <div className="group flex items-center gap-3 px-4 py-3">
      <Text variant="studio/body/medium/sm" className="text-secondary w-8 shrink-0">
        {formattedIndex}
      </Text>

      <div className="bg-tertiary relative h-10 w-[72px] shrink-0 overflow-hidden rounded-md">
        {thumbnailUrl ? (
          <AssetLibraryThumbnail
            assetType="MEDIA_VIDEO"
            thumbnailURL={thumbnailUrl}
            className="h-full w-full"
          />
        ) : (
          <div className="bg-tertiary h-full w-full" />
        )}
      </div>

      <Text
        variant="studio/body/medium/sm"
        className="text-primary min-w-0 flex-1 truncate"
        title={label}
      >
        {label}
      </Text>

      <CheckmarkIcon className="text-green h-5 w-5 shrink-0" />

      <Button
        onClick={(event) => {
          event.stopPropagation();
          onRemove();
        }}
        variant="tertiary"
        size="sm"
        className="text-secondary shrink-0 opacity-0 transition-opacity group-hover:opacity-100"
        icon={<CrossIcon />}
      />
    </div>
  );
}
